import React from "react";

const MyOrders = () => {
  return <div>order</div>;
};

export default MyOrders;
